import { render, staticRenderFns } from "./propertyRightRegistrationManageList.vue?vue&type=template&id=01fcd1e6&scoped=true"
import script from "./propertyRightRegistrationManageList.vue?vue&type=script&lang=js"
export * from "./propertyRightRegistrationManageList.vue?vue&type=script&lang=js"
import style0 from "./propertyRightRegistrationManageList.vue?vue&type=style&index=0&id=01fcd1e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fcd1e6",
  null
  
)

export default component.exports